import React, { ReactNode } from 'react';
import classNames from 'classnames';
import { BASE_CLASS as defaultClassName } from './utils';
import { Transition } from 'react-transition-group';
import useCallbackRef from 'hooks/useCallbackRef';
import useHeightAnimation from 'hooks/useHeightAnimation';

import './Collapse.styles.scss';
import './Collapse.styles.responsive.scss';

type CollapseProps = {
  active: boolean;
  duration?: number;
  children?: ReactNode;
};

const Collapse: React.FC<CollapseProps> = (props) => {
  const { children, active, duration = 330 } = props;

  const [element, ref] = useCallbackRef<any>();

  const { classes } = useHeightAnimation({
    element,
    defaultOpen: active,
    duration,
  });

  return (
    <Transition in={active} appear unmountOnExit timeout={duration}>
      {(state) =>
        ['exiting', 'entering'].includes(state) ? (
          <div
            ref={ref}
            className={classNames(classes, defaultClassName, 's-anim-collapse')}
          >
            {children}
          </div>
        ) : (
          children
        )
      }
    </Transition>
  );
};

export default Collapse;
